import React from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import CurrencySign from 'components/price/CurrencySign.component';
import DELAY from 'constants/delay.const';
import delayed from 'utils/functions/delayed.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import { convertToMoneyAfterVat } from 'reports/utils';

class ExistingClientsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      existingClients: [],
    };
  }

  sortArrayBaccordingToArrayA = (a, b) => {
    const IDs = a.map((e) => e.id);
    const newB = [];
    for (let i = 0; i < IDs.length; i += 1) {
      const elementArray = b.filter((s) => s[0] === IDs[i].toString());
      if (elementArray.length > 0) {
        const e = elementArray[0];
        newB.push(e);
      }
    }
    return newB;
  };

  makeExistingClientsTable = (data) => {
    const newClients = data.stylists.slice();
    const unsortedAppointment = Object.entries(this.props.appointmentsReport.stylist_group);
    const allClientsAppointment = this.sortArrayBaccordingToArrayA(
      this.props.stylistIDInCalendarOrder,
      unsortedAppointment,
    );
    const allClientsRebook = Object.entries(this.props.rebookingReport.stylists);
    const existingClients = [];
    const { stylistIDInCalendarOrder } = this.props;
    for (let i = 0; i < allClientsAppointment.length; i += 1) {
      const stylistId = allClientsAppointment[i][0];
      const found = stylistIDInCalendarOrder.filter((s) => s.id.toString() === stylistId.toString());
      if (found.length === 0) {
        continue; // deleted stylist don't show
      }
      const { name } = allClientsAppointment[i][1];
      const newClientObj = newClients.filter((c) => parseInt(c.id, 10) === parseInt(stylistId, 10));
      let newClient = {
        new_clients: 0,
        revenue: 0,
        booked_online: 0,
        rebooked: 0,
        av_booking_value: 0,
      };
      if (newClientObj.length > 0) {
        [newClient] = newClientObj;
      }
      const allRebooksArr = allClientsRebook.filter((item) => item[0] === stylistId); // [0][1].unique_visits;
      let allRebooks = 0;
      if (allRebooksArr.length) {
        allRebooks = allRebooksArr[0][1].unique_visits;
      }
      const existingVisits = allRebooks - newClient.new_clients;
      const allBookings = allClientsAppointment[i][1].total;
      const existingBookings = allBookings - newClient.revenue;
      const allBookedOnline = allClientsAppointment[i][1].ncob_count;
      const existingBookedOnline = allBookedOnline - newClient.booked_online;
      const allRebookingArr = allClientsRebook.filter((r) => r[0].toString() === stylistId);

      let allRebooking = 0;
      let existingRebooking = 0;
      if (allRebookingArr.length > 0) {
        allRebooking = allRebookingArr[0][1].rebooked;
        existingRebooking = allRebooking ? allRebooking - newClient.rebooked : 0;
      }
      existingClients.push({
        name,
        visits: existingVisits,
        revenue: existingBookings,
        av_revenue: existingVisits > 0 ? existingBookings / existingVisits : 0,
        booked_online: existingBookedOnline,
        rebooked: existingRebooking,
      });
    }

    const visits = this.props.rebookingReport.unique_visits - data.total_new_clients;
    const revenue = this.props.appointmentsReport.total_price - data.total_revenue;
    const total = {
      name: 'Salon total',
      visits,
      revenue,
      av_revenue: visits > 0 ? revenue / visits : 0,
      booked_online: this.props.appointmentsReport.ncob_total - data.total_booked_online,
      rebooked: `${this.props.rebookingReport.rebooked_appointments - this.props.newClientsReport.total_rebooked}`,
    };
    if (existingClients.indexOf(total) < 0) {
      existingClients.push(total);
    }
    this.setState({ existingClients });

    return existingClients;
  };

  render() {
    const { existingClients } = this.state;
    if (
      this.props.newClientsReport &&
      Object.entries(this.props.appointmentsReport.stylist_group).length > 0 &&
      Object.entries(this.props.rebookingReport.stylists).length > 0 &&
      existingClients.length === 0
    ) {
      // TODO: check if this method causes any side effects and remove if it doesn't
      delayed(DELAY.flash, () => void this.makeExistingClientsTable(this.props.newClientsReport));
    }

    return (
      <div id="existing-clients">
        <div className="t-bgr cfix">
          <div className="t-wrap">
            <h2>Existing Clients</h2>
            <div className="t-exist cfix">
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-xls-button"
                table="table-to-xls-7"
                filename="Existing Clients"
                sheet="tablexls"
                buttonText="DOWNLOAD TO EXCEL"
              />
              <table className="existing-client-tbl" id="table-to-xls-7">
                <tbody>
                  <tr>
                    <td colSpan="3">
                      <div className="date-in-tbl-for-export">
                        From <strong>{this.props.startDate}</strong> to <strong>{this.props.endDate}</strong>{' '}
                      </div>
                    </td>
                  </tr>
                  <tr className="t-h first-row">
                    <th className="a3 h" style={{ width: '168px' }}>
                      Staff
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div>Client visits minus new client visits</div>
                        </span>
                      </span>
                      <span className="column-title"> Existing client visits</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div>Total booking value minus value of new clients</div>
                        </span>
                      </span>
                      <span className="column-title">Value of existing clients</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div>Value of existing clients divided by number of existing client visits</div>
                        </span>
                      </span>
                      <span className="column-title"> Average booking value</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div>Total clients who booked online minus new clients who booked online</div>
                        </span>
                      </span>
                      <span className="column-title">Existing clients booked online</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div>Total clients rebooked minus new clients rebooked</div>
                        </span>
                      </span>
                      <span className="column-title">Existing clients rebooked</span>
                    </th>
                    <th style={{ width: 'auto' }} />
                  </tr>
                  {existingClients &&
                    existingClients.length > 0 &&
                    existingClients.map((st, index) => (
                      <tr className="t-h" key={createNodeKey({ index, tag: st.name })}>
                        <td className="stylist-name">{st.name}</td>
                        <td className="t-value">{st['visits']}</td>
                        <td className="t-value">
                          <CurrencySign />
                          {convertToMoneyAfterVat(st['revenue'])}
                        </td>
                        <td className="t-value">
                          <CurrencySign />
                          {convertToMoneyAfterVat(st['av_revenue'])}
                        </td>
                        <td className="t-value">{st['booked_online']}</td>
                        <td className="t-value">{st['rebooked']}</td>
                        <td />
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ExistingClientsTable;
